/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable object-shorthand */
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FormattedMessage } from "react-intl";
import { useRouter } from "next/router";
import { useLeavePageConfirm } from "../../common/hooks/useLeavePageConfirm";
import { IQuizState } from "../utils/type";
import { getNonce, genSignature, isEmpty } from "../../../utils/helpers/helpers";
import "../topics.module.scss";
import QuizCoreView from "../../common/components/QuizComponents/QuizCoreView";
import AlertDialog from "../../common/dialog/AlertDialog";
import { quizActions } from "../redux/actions";
import { CXCircularProgress } from "../../common/components/CircularProgress";
import { ERROR_CODE_NEED_BUY_VIP, ERROR_CODE_NEED_LOGIN, QUIZ_TYPE_EXAM } from "../../common/utils/constant";
import ViewAdsEarnDiamond from "../../common/components/ViewAdsEarnDiamond";
import { ERROR_CODE_NOT_ENOUGH_DIAMOND } from "../utils/constants";
import { commonActions } from "../../common/redux/actions";
import { eventTracking } from "../../../firebase/firebaseConfig";
import { DebuggerMessage } from "../../../utils/constants/constants";
import { TCommonState } from "../../common/utils/type";

function PracticeDetail({ props }) {
  // const { topicId } = props;
  const router = useRouter();
  const { practice } = props;

  const {
    // practice,
    progress,
    isLoading,
    action,
    notify,
    quizInfoSolution,
    quizInfoStart,
    quizInfoSubmit,
    dataAnalysis,
    answerTotal,
    quizStartTime,
    congratulation
  } = useSelector((state: { quizCore: IQuizState }) => state.quizCore);
  const { hideDialogSurvey } = useSelector((state: { commonNew: TCommonState }) => state?.commonNew);
  const [dataList, setDataList] = useState<any>([]);
  // const [showDialog, setShowDialog] = useState(false);
  const [openDialogViewsAds, setOpenDialogViewsAds] = useState(false);

  const [leavePageConfirm, setLeavePageConfirm] = useState(true);
  useLeavePageConfirm(isEmpty(progress) && leavePageConfirm);
  const dispatch = useDispatch();
  const fetchQuizzesSolutions = () => {
    // router.push({ pathname: router?.pathname, query: { ...router?.query, p: "ket-qua" } }, undefined, {
    //   shallow: true
    // });
    const paramsPre = {
      timestamp: moment().unix(),
      nonce: getNonce(),
      topic_slug: router?.query?.topicId
    };
    const params = {
      ...paramsPre,
      signature: genSignature(paramsPre)
    };
    dispatch(quizActions.handleGetQuizSolution(params));
  };

  const fetchAnalysis = () => {
    dispatch(quizActions.handleGetAnalysis(router?.query));
  };

  const fetchQuizzesStart = (quizInfoToken: string) => {
    const dataPostPre = {
      quiz_info_token: quizInfoToken,
      timestamp: moment().unix(),
      nonce: getNonce()
    };
    const dataPost = {
      ...dataPostPre,
      signature: genSignature(dataPostPre)
    };
    dispatch(quizActions.handlePostQuizStart(dataPost));
  };

  const fetchPutQuizzesStart = (quizInfoToken: string) => {
    const dataPostPre = {
      quiz_info_token: quizInfoToken,
      timestamp: moment().unix(),
      nonce: getNonce()
    };
    const dataPost = {
      ...dataPostPre,
      signature: genSignature(dataPostPre)
    };
    dispatch(quizActions.handlePutQuizStart(dataPost));
  };
  // const fetchExamDetail = () => {
  //   dispatch(quizActions.handleGetExamsDetail({ topicId: topicId }));
  // };

  const continueFunction = () => {
    dispatch(quizActions.handleCleanQuizInfo());
    dispatch(quizActions.handleSaveQuizTime(moment().unix()));
    fetchQuizzesStart(practice?.quiz_info_token);
  };
  const redoFunction = () => {
    dispatch(quizActions.handleCleanQuizInfo());
    dispatch(quizActions.handleSaveQuizTime(moment().unix()));
    fetchPutQuizzesStart(practice?.quiz_info_token);
  };
  const cleanCongratulation = () => {
    dispatch(quizActions.handleCleanCongratulation());
  };
  const handleSetQuizInfoSolution = (params) => {
    dispatch(quizActions.handleUpdateQuizInfoSolution(params));
  };

  const handleSaveAnswerTotal = (dataAnswerTotal: any) => {
    dispatch(quizActions.handleSaveAnswerTotal(dataAnswerTotal));
  };
  useEffect(() => {
    handleSaveAnswerTotal("");
    // DebuggerMessage(`practice: ${JSON.stringify(practice)}`)
    if (action?.type === "GET_QUIZ_QUESTIONS_SUCCESS") {
      DebuggerMessage(`Progress ${JSON.stringify(progress)}`);
      if (!!progress?.finished_quiz && progress?.topicId === practice.id) {
        fetchQuizzesSolutions();
        if (practice?.subject?.type === QUIZ_TYPE_EXAM) {
          fetchAnalysis();
        }
      } else if (!progress) {
        fetchQuizzesStart(practice?.quiz_info_token);
      }
    }
  }, [practice?.quiz_info_token, progress]);

  useEffect(() => {
    eventTracking(router?.pathname?.includes("de-thi") ? "view_exam" : "view_practice", {
      id: practice?.id,
      title: practice?.title,
      link: practice?.reference?.direct_link
    });

    if (progress && action?.type === "GET_QUIZ_SOLUTION_SUCCESS") {
      const tempDataShow = quizInfoSolution?.results?.map((element) => element?.quiz_question_id);
      const tempDataList = practice?.items?.filter((t) => tempDataShow?.includes(t?.id));
      setDataList(tempDataList);
    } else if (action?.type === "POST_QUIZ_START_CORE_SUCCESS") {
      const tempDataList =
        quizInfoStart?.question_ids.length > 0
          ? practice?.items?.filter((t) => quizInfoStart?.question_ids?.includes(t?.id))
          : practice?.items;
      setDataList(tempDataList);
    }
  }, [quizInfoStart?.question_ids, practice, quizInfoSolution, action]);

  useEffect(() => {
    if (action?.type === "SUBMIT_QUIZ_SUCCESS") {
      fetchQuizzesSolutions();
      if (practice?.subject?.type === QUIZ_TYPE_EXAM) {
        fetchAnalysis();
      }
    } else if (action.type === "POST_QUIZ_START_CORE_SUCCESS" || action.type === "PUT_QUIZ_START_SUCCESS") {
      dispatch(quizActions.handleSaveQuizTime(moment().unix()));
      if (action.type === "POST_QUIZ_START_CORE_SUCCESS" && practice?.subject?.type === "exam") {
        dispatch(commonActions.handleSaveIsUpdateInfo(true));
      }
    }
  }, [action]);
  useEffect(() => {
    if (!isEmpty(notify?.errorCode)) {
      setLeavePageConfirm(false);
    }
    if (notify?.errorCode === ERROR_CODE_NOT_ENOUGH_DIAMOND) {
      setOpenDialogViewsAds(true);
      // dispatch(quizActions.handleCleanNotify());
    }
  }, [notify]);

  useEffect(() => {
    if (hideDialogSurvey !== openDialogViewsAds) {
      dispatch(commonActions.handleHideDialogSurvey(openDialogViewsAds));
    }
  }, [openDialogViewsAds]);

  useEffect(() => {
    return () => {
      dispatch(quizActions.handleCleanQuizInfo());
    };
  }, []);

  if (isLoading)
    return (
      <div className="h-screen bg-white">
        <CXCircularProgress height="30vh" />
      </div>
    );

  return (
    <>
      <div className="min-h-[50vh]">
        <QuizCoreView
          quizDetail={practice}
          progress={progress}
          quizInfoStart={quizInfoStart}
          quizInfoSolutions={quizInfoSolution}
          quizInfoSubmit={quizInfoSubmit}
          answerTotal={answerTotal}
          handleSaveAnswerTotal={handleSaveAnswerTotal}
          startTime={moment.unix(quizStartTime)}
          isArena={false}
          dataList={dataList}
          continueFunction={continueFunction}
          redoFunction={redoFunction}
          notify={notify}
          dataAnalysis={dataAnalysis}
          fetchUserInfos={() => dispatch(commonActions.handleGetUserInfo())}
          congratulation={congratulation}
          cleanCongratulation={() => cleanCongratulation()}
          setLeavePageConfirm={() => {}}
          setQuizInfoSolutions={handleSetQuizInfoSolution}
        />
      </div>
      {notify?.isOpenDialog && notify?.errorCode !== ERROR_CODE_NOT_ENOUGH_DIAMOND && (
        <AlertDialog
          title={<FormattedMessage id="Setting.notification" />}
          open={notify?.isOpenDialog}
          setOpen={() => {}}
          triggerFunc={() => {
            dispatch(quizActions.handleCleanNotify());
            setLeavePageConfirm(false);
            dispatch(quizActions.handleCleanQuizInfo());
            // if (notify?.errorCode === "EBADND") {
            //   // router.push("/");
            //   setOpenDialogViewsAds(true);
            // }
            if (notify?.errorCode === ERROR_CODE_NEED_LOGIN) {
              dispatch(commonActions.handleOpenModalLogin({ isOpen: true }));
            }
            if (notify.errorCode === ERROR_CODE_NEED_BUY_VIP) {
              router.push("/kim-cuong/nang-cap-vip");
            }
          }}
          styleContent={{ width: "100%", textAlign: "center" }}
          content={`${notify?.message}(${notify?.errorCode})`}
          buttonOkKey="common.ok"
          isHideCancel={!(notify.errorCode === ERROR_CODE_NEED_BUY_VIP)}
          cancelFunc={() => {
            setLeavePageConfirm(false);
            router.push("/");
            dispatch(quizActions.handleCleanNotify());
          }}
          notifyError
        />
      )}
      <ViewAdsEarnDiamond
        openAlertDialog={openDialogViewsAds}
        setOpenAlertDialog={setOpenDialogViewsAds}
        isShowCongratulation={notify?.errorCode !== ERROR_CODE_NOT_ENOUGH_DIAMOND}
        triggerFunc={() => {
          // fetchExamDetail();
          if (notify?.errorCode === ERROR_CODE_NOT_ENOUGH_DIAMOND) {
            setLeavePageConfirm(true);
            router?.push(router?.asPath);
            dispatch(quizActions.handleCleanNotify());
          }
        }}
        cancelFunction={() => {
          // setLeavePageConfirm(false)
          dispatch(quizActions.handleCleanNotify());
          setOpenDialogViewsAds(false);
          router.push(`/${router?.query?.grade}/${router?.query?.subjectsId}`);
        }}
      />
    </>
  );
}

export default PracticeDetail;
